$.fn.CurvedBox = function(id = 'clip') {
  let self = this

  self.css('--clip-id', "url('#" + id + "')");
  self.find('.boxed-section-clip').attr('id', id);

  self.resizeMask = function() {
    let maskWidth = self.width(),
    maskHeight = self.height()

    curve_scale = (maskWidth - 40) / 1253;
    curve_offset = 20;
    curve_offset = curve_offset / curve_scale;

    self.find('.boxed-section-clip__curve').attr('cx', 40)
    self.find('.boxed-section-clip__c4').attr('cx', maskWidth - 20)
    self.find('.boxed-section-clip__c1').attr('cy', maskHeight - 20)
    self.find('.boxed-section-clip__c2').attr('cy', maskHeight - 20).attr('cx', maskWidth - 20)
    self.find('.boxed-section-clip__c3').attr('cy', 40)
    self.find('.boxed-section-clip__r1').attr('width', maskWidth).attr('height', maskHeight - 60)
    self.find('.boxed-section-clip__r2').attr('width', maskWidth - 40).attr('height', maskHeight)
    self.find('.boxed-section-clip__curve').css('transform', 'scaleX(' + curve_scale  + ') translateX(' + curve_offset + 'px)')

  }
  self.resizeMask();

  return function() {
    $(window).on('resize orientationchange load', self.resizeMask)
    return self
  }()
}
